
import { Component, OnInit, Input, Output, OnDestroy, TemplateRef } from '@angular/core';
//import * as _ from "underscore";
import {UsersService} from '../../../shared/services/users.service';
import {DataContextService} from '../../../shared/services/data-context.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// import { EditUserComponent } from '../edit-user/edit-user.component';
import { ConfirmationModalComponent } from '../../../shared/confirmation-modal/confirmation-modal.component';
// import {ToastrService} from 'ngx-toastr';
import { ComponentName, ModalSize, OnStatus } from 'src/app/Enum/usersFilterEnums';
import { ConstantsService } from '../../../shared/services/Constants/constants.service'
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import {Subject} from 'rxjs';
import { SortBy } from 'src/app/Enum/sortEnums';
import { filterData, UsersFilterService } from 'src/app/shared/classes/filter';
import { EditUserComponent } from '../edit-user/edit-user.component';
import { User } from 'src/app/shared/classes/users';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { UserModalComponent } from '../user-modal/user-modal.component';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-users-table',
  templateUrl: './users-table.component.html',
  styleUrls: ['./users-table.component.less']
})



export class UsersTableComponent implements OnInit, OnDestroy {
    
  tableSetting: any;
  val:any;
  usersList: any;
  userModel : any;
  //need to remove in future
  cityList :any;
  roleList :any;
  officeList :any;
  showMoreOffice:boolean;
  totalCount: number;
  rowsperpage: number;
  currentIndex: number;
  appUserId:number;
  p: number = 1;
  //offset: any;
  errorMessage: string;
  showError: boolean;
  showNoResult: boolean = false;
  displaysort: boolean = false;
  emailArray: Array<any> = new Array();
  roleArray: Array<any> = new Array();
  cityArray: Array<any> = new Array();
  officeArray: Array<any> = new Array();
  statusArray: Array<any> = new Array();
  filterData = {} as filterData;
  officeData:any;
  cityData:any;
  officeName:string[];
  cityName:string[];
  //userPersonnelNo:number;
  userName : any;
  modalRef: BsModalRef;
  personelNumber : number;
  usrName:string;
  itemsperPage : number =10;
  countLength:number;
  isPaginationChange : boolean = false;
  displayUserName:string;
  userSpecific : any;
  private unsubscribe$ =new Subject<void>();
  //isSortedDecending : boolean = true;
  private service_URL: any;
    statusList: any;
  constructor(private userService :UsersService, private modalService: BsModalService,private _dataContextService : DataContextService,
     private toast : ToastrService,private trackeromnitureservice:TrackerOmnitureService
    ) { 
        this.service_URL=ConstantsService;
        this.filterData.page = 1;  
        // this.filterData.sortOrder = 'Desc';

  }


  public ngOnInit() {    
    this.userService.refreshPage
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
        this.isPaginationChange=false; 
        this.ResetUserObjects();
        this.getUsersData();
    });

    this.userService.refreshwithFilters
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {  
        this.isPaginationChange = false;
        this.getUsersData();
    });

    this.userService.deleteUser
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(() => {
      this.DeleteAlert(this.appUserId, this.userSpecific);
      //this.confirmDeleteUser(this.appUserId, this.userName,this.status);           
    });

    this.tableSetting = {
        columns: this.tableSettingColumns()
    };
      
      this.getUsers();
      this.getUsersData();

      var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('user',username);
    this.trackeromnitureservice.trackPage("pageView");
      
      //this.setIntialPageCount();
     //this.setInitialUserData();
  }
  // popuptemplates(popuptemplate :TemplateRef<any>,appUserId:number,userName:string )
  // {
      
    
  //    this.modalRef = this.modalService.show(popuptemplate, Object.assign({ backdrop: 'static' }, { class: 'modal-md' }));
  //    this.officeName=this.officeData.find(office=>office.id==appUserId).name;
  //    this.displayUserName=userName;
  // }
  //  popuptemplatesCity(popuptemplate :TemplateRef<any>,appUserId:number,userName:string )
  // {
      
    
  //   this.modalRef = this.modalService.show(popuptemplate, Object.assign({ backdrop: 'static' }, { class: 'modal-md' }));
  //    this.cityName=this.cityData.find(city=>city.id==appUserId).name;
  //    this.displayUserName=userName;
  // }
  modalclose(popuptemplate:TemplateRef<any>){
     this.modalRef.hide();
  }

  openUserDetails(userDetails: any){
    this.modalRef = this.modalService.show(UserModalComponent,{
        initialState: {
            userModalDetails: userDetails
        }
    });
    this.modalRef.setClass(ModalSize.Large);
  }

  editUser(appUserId:any){
    this.modalRef = this.modalService.show(EditUserComponent,{
        initialState: {
            userPersonnelNo: appUserId
        },
        class: 'add-user-modal-xl'
    });
  }

    getColour(val) {
          if (val.isApprover)
           {
             if (val.isL1 && val.isL2) 
             {
                return 'L1|L2';
             } 
             else {
                if(val.isL1)
                {
                    return 'L1';
                }
                else return 'L2';
                }
            }
            else return 'No';
        }
    

    deleteUser(appUserId:number,user:any)
    {
        // console.log(user);
        this.userSpecific = user;
        this.appUserId = appUserId;
        this.userName=user.firstName;
        this.modalRef = this.modalService.show(ConfirmationModalComponent);
        this.modalRef.setClass(ModalSize.Small);
        this.modalRef.content.title = 'Delete user';
        this.modalRef.content.description = 'Are you sure you want to delete <b>' + this.userName +'</b>?'; 
        this.modalRef.content.buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'Delete',
        component: ComponentName.Users
    }
    }

    convertToIST(date: any){
        date.setHours(date.getHours() + 5);
        date.setMinutes(date.getMinutes() + 30);
        var isodate = date.toISOString();
    
        return isodate;
      }

    DeleteAlert(appUserId: number, user:any) {
        if(user.isActive == false){
            this.toast.error("User was already deleted");
            return ;
        }
        let url = this.service_URL.Users.deleteUser + '/' + appUserId;       
        // let data = {
        //   id: selectedOfficeID
        // };
            this._dataContextService.postDatawithValuesForDel<any>(url)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(res => {
                // console.log(res);
                if (res=="3") {                
                    //ToastrComponent.success("Successfully deleted!");                
                    this.toast.error("Some thing went on wrong..");
           
                }
                else if(res=="1"){
                    this.toast.error("User was deleted");
                    this.userService.refreshwithFilters.next();
                    //this.getallUsersData();
                    this.getUsers();
                    this.modalRef.hide();
                                  
                }
                else{
                    this.toast.error("Some thing went on wrong..")
                }
                
            },
            (err) => {
                console.log(err);
            },
            () => {
                var primaryKey = this.usersList.filter((x) => {
                    return x.appUserID == appUserId
                  })[0].emailId;
        
                  var isActive = this.usersList.filter((x) => {
                    return x.appUserID == appUserId
                  })[0].isActive;
        
                  var data : AuditData = {
                      changedAttribute: 'Status',
                      oldValue: isActive ? 'Active' : 'Inactive',
                      newValue: 'Inactive'
                  }
        
                  if(isActive){
                    let auditParams = {
                      actionPerformed : "Delete",
                      actionPerformedOn : "User",
                      changedBy : localStorage.getItem('email'),
                      dateChanged : this.convertToIST(new Date()),
                      primaryKey : primaryKey,
                      messageText : [data]
                    };
                
                    this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.saveconfigaudittrail,auditParams)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((res) => {
                      // console.log(res);
                    })
                }
            })
        }
    
  setInitialUserData()
  {
      this.rowsperpage =10;
      
  }

//get the city list from api
loadCityOptions(citydata : any) {   
    this.cityList = citydata;
    this.cityArray = citydata;     
    this.checkFilterOptions(this.cityArray,UsersFilterService.cityList);     
    this.tableSetting.columns[3].isFilterIcon = true;
}
loadRoleOptions(roledata : any) {   
    this.roleList = roledata;
    this.roleArray = roledata;  
    this.checkFilterOptions(this.roleArray,UsersFilterService.roleList);     
    this.tableSetting.columns[2].isFilterIcon = true;
}
loadOfficeOptions(officedata : any) {   
    this.officeList = officedata;
    this.officeArray = officedata;  
    this.checkFilterOptions(this.officeArray,UsersFilterService.officesList);     
    this.tableSetting.columns[4].isFilterIcon = true;
}
loadStatusOptions(statusdata: any) {
    this.statusList = statusdata;
    this.statusArray = statusdata;
    this.checkFilterOptions(this.statusArray,UsersFilterService.statusList);     
    this.tableSetting.columns[5].isFilterIcon = true;
  }

checkFilterOptions(filterArray,filterList)
{
    if(filterArray)
    {
        filterArray.forEach(item => {
            item.description = item.name;
        })
        //  _.each(filterArray, function (item) {            
        //     item.description = item.name;                  
        // })
    }
    if(filterList.length == 0){
        filterArray.forEach(item =>{
            item.isCheck = true;
        })
        // _.each(filterArray, function (item) {
        //     item.isCheck = true;
        // })
    }
    else{
        filterArray.forEach(item => {
            filterList.forEach(item1 =>{
                if(item.description == item1){
                    item.isCheck = true;
                }
            })
        })

        // _.each(filterArray, function (item) {
        //     _.each(filterList, function (item1){
        //         if(item.description == item1){
        //             item.isCheck = true;
        //         }
        //     })
            
        // })
        
    }
}
//         })
//         // _.each(filterArray, function (item) {
//         //     item.isCheck = true;
//         // })
//     }
//     else{
//         filterArray.forEach(item => {
//             filterList.forEach(item1 =>{
//                 if(item.description == item1){
//                     item.isCheck = true;
//                 }
//             })
//         })

//         // _.each(filterArray, function (item) {
//         //     _.each(filterList, function (item1){
//         //         if(item.description == item1){
//         //             item.isCheck = true;
//         //         }
//         //     })
            
 //         // })
        
//     }
// }

searchUsersByName(val)
{
    this.isPaginationChange = false;
    this.userName = val;
    this.filterData.page = 1;
    this.getUsersData();
}

resetFilters(val)
{
    this.userName = val;    
}

getUsersData() {

     let data = this.PrepareUsersObj();  
    this._dataContextService.postDatawithValues<any>(this.service_URL.Users.getUserDetailsByFilter, data)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
         this.userModel = res; 
         this.usersList = res.users;
         this.usersList.forEach(user => {
         user.cityNamesArray = user.cityNames ? user.cityNames.split(',').map(c => c.trim()) : [];
         user.officeNamesArray = user.officeNames ? user.officeNames.split(',').map(o => o.trim()) : [];
      });
    
         this.totalCount = res.totalRecords;
        //  this.cityData = res.userCities;  
        //  this.officeData=res.userOffices;
        //Removing duplicate cities
        const resultCities = Array.from(new Set(res.cities.map(s => s.id)))
        .map(id => {
            return {
                id: id,
                name: res.cities.find(s => s.id === id).name,
                description: res.cities.find(s => s.id === id).description,
                isCheck: res.cities.find(s => s.id === id).isCheck
            }
        })
        const resultRoles = Array.from(new Set(res.roles.map(s => s.id)))
        .map(id => {
            return {
                id: id,
                name: res.roles.find(s => s.id === id).name,
                description: res.roles.find(s => s.id === id).description,
                isCheck: res.roles.find(s => s.id === id).isCheck
            }
        })
        const resultOffices = Array.from(new Set(res.offices.map(s => s.id)))
        .map(id => {
            return {
                id: id,
                name: res.offices.find(s => s.id === id).name,
                description: res.offices.find(s => s.id === id).description,
                isCheck: res.offices.find(s => s.id === id).isCheck
            }
        })
         this.loadCityOptions(resultCities); 
         this.loadRoleOptions(resultRoles);
         this.loadOfficeOptions(resultOffices);
         this.loadStatusOptions(res.status);
        //  this.loadOfficeOptions(res.offices);
        //  this.loadRoleOptions(res.roles);
        //  this.usersList.forEach((userlist)=>{
        //      this.officeData.forEach(officelist=>{
        //         if(userlist.appUserId==officelist.id) {
        //             userlist.officeData= officelist.name.length;
        //         }
        //      })
        //  })
        //  this.usersList.forEach((userlist)=>{
        //     this.cityData.forEach(citylist=>{
        //        if(userlist.appUserId==citylist.id) {
        //            userlist.cityData= citylist.name.length;
        //        }
        //     })
        // })
         if(!this.isPaginationChange){this.setIntialPageCount(this.totalCount);}     
                
    })
    
}







checkFilterApplied(val){
    this.isPaginationChange = false;
    if(val){
        
        this.filterData.sortBy = UsersFilterService.sortBy;
        this.filterData.sortOrder = UsersFilterService.sortOrder;
        this.filterData.page = 1;
        this.p = 1;
        this.checkFilterValue();
        this.getUsersData();
        
    }else{
        this.usersList = [];

    }
}

checkFilterValue(){
    this.tableSetting.columns.forEach(item =>{
        if(UsersFilterService.sortBy != item.sortBy){
            item.isFilterApplied = false;
        }
    })
}



PrepareUsersObj() {
    var sArray: Array<boolean> = new Array();
  
  UsersFilterService.statusList.forEach(element => {
    element === 'Active' ? sArray.push(true) : sArray.push(false);
  });
    let params = {
        Status: sArray,       
        Role: UsersFilterService.roleList,
        Office: UsersFilterService.officesList,
        City: UsersFilterService.cityList,
        SearchByName:  this.userName,
        PageNo: this.filterData.page,
        //SortOrder : this.filterData.sortOrder
         
    };

    return params;
}



ResetUserObjects() {
    UsersFilterService.statusList = [];
    UsersFilterService.roleList = [];
    UsersFilterService.officesList = [];
    UsersFilterService.cityList = [];
    this.userName = '';
    this.filterData.page = 1;
    this.filterData.sortOrder = 'Desc';
}


getUsers() {
    this.userService.getUsersData()
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((data) => {
      this.usersList = data;
    })
      
}

setIntialPageCount(totalrecords : number)
  {
      this.isPaginationChange = true;
      if (totalrecords > this.itemsperPage) {
          this.countLength = this.itemsperPage;
      }
      else {
          this.countLength = totalrecords;
      }
  }

  //Column settings
  tableSettingColumns() {
    return [        
        {
            Id:1,
            title: "Name",            
            sortBy: SortBy.Name,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: false,
            isStaticColumn: false,
            isSortable : true
        },
        {
            Id:2,
            title: "Email",            
            sortBy: SortBy.Email,
            isFilterApplied:false,
            displaysort: false,   
            isFilterIcon: false ,
            isStaticColumn: false ,
            isSortable : true                                    
        },
        {
            Id:3,
            title: "Role",            
            isSortable: false,           
            // isResNameSortN: false,
            sortBy: SortBy.Role,
            roleDropdown:true,
            isFilterApplied:false,
            displaysort: false,   
            //isOnlyFilter:true,         
            isFilterIcon: true
        },
        {
            Id:4,
            title: "City",            
            // isResNameSortN: true,
            sortBy: SortBy.City,
            cityDropdown:true,
            isFilterApplied: false,
            displaysort: false,
            //isOnlyFilter:true,
            isFilterIcon: true,
            isStaticColumn: false,
            //isSelected : false,
            isSortable : false
        },
        {
            Id:5,
            title: "Work Location",            
            //isSortable: true,
            // isResNameSortN: true,
            sortBy: SortBy.Office,
            officeDropdown: true,
            isFilterApplied: false,
            displaysort:false,
            isFilterIcon: true,
            isStaticColumn: false,
            isSortable : false
        },
       
        {
            Id:6,
            title: "Status",            
            statusDropdown: true,
            sortBy: SortBy.Status,
            isFilterApplied: false,
            displaysort: false,
            isFilterIcon: true,
            isStaticColumn: false,
            isSortable : false
        }
        // {
        //     Id:6,
        //     title: "IsRequestor",            
        //     statusDropdown: false,
        //     sortBy: SortBy.Status,
        //     isFilterApplied: false,
        //     displaysort: false,
        //     isFilterIcon: true,
        //     isStaticColumn: false,
        //     isSortable : false
        // },
        // {
        //     Id:7,
        //     title: "IsApprover",            
        //     statusDropdown: true,
        //     sortBy: SortBy.Status,
        //     isFilterApplied: false,
        //     displaysort: false,
        //     isFilterIcon: true,
        //     isStaticColumn: false,
        //     isSortable : false
        // }
        ];
  }

  changeCurrentPage(event){
    
    this.filterData.page = event.page;    
      if ((this.totalCount / (this.filterData.page * this.itemsperPage) > 1)) {
        this.countLength = this.filterData.page * this.itemsperPage
    }
    else {
        this.countLength = this.totalCount;
    }
    this.getUsersData();
}

  //Sorting popup
showSortingPopup(obj) {
    this.tableSetting.columns.forEach(item => {
        if (item.Id != obj.Id) {
            item.displaysort = false;
        }
    })
   
    obj.displaysort = !obj.displaysort;
}

hideDropdowns() {
    this.tableSetting.columns.forEach(item =>{
        item.displaysort = false;
    })

}

closeDropDown() {
    this.usersList.columns.forEach(item =>{
        item.showAssigneeDropdown = false;
        item.showStatusDropdown = false;
    })
  
  }

ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


}
